import { productType } from '../types';
import { translateFn } from '../../../utils/translator.helper';

export const SupportUrls = {
  TECHNICAL_ASSISTANCE: 'https://www.bitdefender.com/support/contact-us.html?last_page=BusinessCategory'
};
